/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import PickerOption from "./PickerOption";

const OccupantTypePicker = ({
  values,
  setValues,
}: {
  values: string[];
  setValues: (values: string[]) => void;
}) => {
  const select = (mode: string) => {
    if (mode === "") return setValues(["koch", "competitor", "customer"]);

    let newValues = [...values];
    if (newValues.length === 3) {
      newValues = [mode];
    } else if (newValues.includes(mode)) {
      newValues.splice(newValues.indexOf(mode), 1);
    } else {
      newValues.push(mode);
    }
    // if (newValues.length === 0) {
    //   newValues = [""];
    // }

    setValues(newValues);
  };

  return (
    <div
      style={{
        display: "flex",
        gap: 10,
      }}
    >
      <PickerOption
        width={90}
        height={46}
        label="All"
        select={() => select("")}
        selected={values.length === 0 || values.length === 3}
      />
      <PickerOption
        width={90}
        height={46}
        label="Customer"
        select={() => select("customer")}
        selected={values.includes("customer") && values.length < 3}
      />
      <PickerOption
        width={90}
        height={46}
        label="Competitor"
        select={() => select("competitor")}
        selected={values.includes("competitor") && values.length < 3}
      />
      <PickerOption
        width={90}
        height={46}
        label="Koch"
        select={() => select("koch")}
        selected={values.includes("koch") && values.length < 3}
      />
    </div>
  );
};

export default OccupantTypePicker;
